import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from './hooks/useAuth';
import AppShell from './components/AppShell';

const Login = lazy(() => import('./pages/Login'));
const Signup = lazy(() => import('./pages/Signup'));
const Lesson = lazy(() => import('./pages/Lesson'));
const Dashboard = lazy(() => import('./pages/Dashboard'));

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: me, isPending } = useMe();
  if (isPending) return <div className="center-loading">Cargando…</div>;
  if (!me) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function GuestOnly({ children }: { children: React.ReactNode }) {
  const { data: me, isPending } = useMe();
  if (isPending) return <div className="center-loading">Cargando…</div>;
  if (me) return <Navigate to="/lessons/day-1" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Suspense fallback={<div className="center-loading">Cargando…</div>}>
      <Routes>
        <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
        <Route path="/signup" element={<GuestOnly><Signup /></GuestOnly>} />
        <Route path="/" element={<RequireAuth><AppShell /></RequireAuth>}>
          <Route index element={<Navigate to="/lessons/day-1" replace />} />
          <Route path="lessons/:slug" element={<Lesson />} />
          <Route path="dashboard" element={<Dashboard />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
